// Shared labels and number formats for the platform-customer report.

export const pad = (n) => String(n).padStart(2, '0');
export const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return toYmd(d); };
export const firstOfMonth = () => { const d = new Date(); d.setDate(1); return toYmd(d); };

export const num = (n) => Number(n || 0).toLocaleString();
// Baht: always 2 decimals.
export const baht = (n) => `฿${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// Translation is billed in USD; shown in baht at a fixed rate (owner, 2026-10-18).
export const USD_THB_RATE = 35;
export const FX_LABEL = `คิดที่ ${USD_THB_RATE} บาท / $1 (อัตราคงที่)`;
export const usdAsBaht = (n) => baht(Number(n || 0) * USD_THB_RATE);
export const pct = (part, whole) => (whole ? `${((part / whole) * 100).toFixed(1)}%` : '—');
export const date = (iso) => (iso ? new Date(iso).toLocaleDateString('th-TH', { timeZone: 'Asia/Bangkok', day: 'numeric', month: 'short', year: '2-digit' }) : '—');
export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—');

// Order of the rows in "Revenue by type" (services/report/platformCustomerReport.js orderRevenue).
export const REVENUE_TYPES = [
  { key: 'product', label: 'ค่าสินค้า', field: 'amount × qty × productRate' },
  { key: 'downFee', label: 'ค่ามัดจำ (down fee)', field: 'isDown → product × downRate%' },
  { key: 'transactionFee', label: 'ค่าธรรมเนียม', field: 'transactionFee − websiteTransactionFee' },
  { key: 'websiteFee', label: 'ค่าธรรมเนียมเว็บไซต์', field: 'websiteTransactionFee' },
  { key: 'extraJpFees', label: 'ค่าส่งตรวจ / ค่าธรรมเนียมญี่ปุ่นอื่น', field: 'extraJpFees.amountThb' },
  { key: 'shipJp', label: 'ค่าส่งในญี่ปุ่น', field: 'deliveryFeeJp × rate' },
  { key: 'weight', label: 'ค่าน้ำหนัก (ญี่ปุ่น → ไทย)', field: 'weightPrice' },
  { key: 'shipTh', label: 'ค่าส่งในไทย', field: 'deliveryFeeTh' },
];

export const MARKETPLACE_LABEL = {
  mercari: 'Mercari',
  'mercari-shop': 'Mercari Shops',
  paypay: 'PayPay',
  'yahoo-auction': 'Yahoo Auction',
  'custom-link': 'ลิงก์สั่งซื้อ (custom link)',
  other: 'อื่น ๆ',
};

export const COUPON_TYPE_LABEL = {
  discount_amount: 'ลดเป็นบาท',
  discount_percentage: 'ลดเป็น %',
  free_shipping: 'ส่งฟรี',
};
